import { Box, Button, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import { ContentLayout } from "../../layout/contentLayout";
import ImageBackground from "../ui-elements/image-background";
import {
  CrownIcon,
  EditIcon,
  NotificationSmallIcon,
} from "../ui-elements/svg-icons";
import BadgeImage from "../ui-elements/badge-image";
import { useNavigate } from "react-router-dom";
import { PATH_ACCOUNT, PATH_ONBOARD } from "../../routes/path";
import useResponsive from "../../hooks/useResponsive";
import { AccountData } from "../../interface/account";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import {
  AccountBookmark,
  AccountPetition,
  AccountPosts,
  AccountReplies,
  AccountSignedPetition,
  AccountTagged,
} from "./account-activity";

const AccountContent = ({ account_data }: { account_data: AccountData }) => {
  const navigate = useNavigate();
  const verification_status = useSelector(
    (state: RootState) => state.content.verification_status
  );
  const badge = useSelector((state: RootState) => state.content.badge_number);
  const account_profile = useSelector(
    (state: RootState) => state.content.account_profile_data
  );
  const paths =
    badge === 2
      ? [
          "Post",
          "Tagged",
          "Signed petition",
          "Petition",
          "Replies",
          "Bookmarks",
        ]
      : ["Post", "Petition", "Replies", "Bookmarks"];
  const [path_name, setPath_name] = useState("Post");

  const isMedium = useResponsive("down", "md", "xl");

  const handle_path_name = (path_name: string) => setPath_name(path_name);

  return (
    <ContentLayout>
      <Box id="main-scroll-container" sx={{}}>
        <Box
          sx={{
            maxWidth: 605,
            mx: "auto",
            py: "80px",
          }}
        >
          <ImageBackground
            sourceCover={
              account_data?.cover_photo_url ??
              "/assets/icons/icon-main.png"
            }
            account={true}
            sourceProfile={
              account_data?.photo_url ?? "/assets/images/account/cover-bg.jpeg"
            }
          />

          <Stack
            direction={"row"}
            justifyContent={"flex-end"}
            sx={{ my: isMedium ? "4rem" : 3, mb: 3 }}
            spacing={2}
          >
            {account_profile?.name && account_profile?.id_uploaded === 0 && (
              <Button
                variant="outlined"
                onClick={() => navigate(PATH_ONBOARD.account)}
                endIcon={<CrownIcon />}
                sx={{
                  borderRadius: "43px",
                  minWidth: isMedium ? "100px" : "120px",
                  height: "2.5rem",
                }}
              >
                {" "}
                Verify account
              </Button>
            )}
            <Button
              variant="contained"
              startIcon={<NotificationSmallIcon />}
              endIcon={<EditIcon />}
              sx={{
                borderRadius: "43px",
                minWidth: isMedium ? "100px" : "120px",
                height: "2.5rem",
              }}
              onClick={() => navigate(PATH_ACCOUNT.edit)}
            >
              {" "}
              Edit profile
            </Button>
          </Stack>
          <Stack direction={"row"} alignItems={"center"} spacing={2}>
            <Stack sx={{}}>
              <Stack direction={"row"} spacing={1} alignItems={"center"}>
                <Typography
                  variant="body1"
                  color="black"
                  sx={{ fontWeight: 600 }}
                >
                  {account_data?.name}
                </Typography>
                <BadgeImage badge={badge} />
              </Stack>
            </Stack>
            {verification_status === "not-complete" && (
              <Stack>
                <img
                  src="/assets/icons/account/un-icon.svg"
                  alt=""
                  width={32}
                  height={32}
                />
              </Stack>
            )}
          </Stack>

          {/*  */}
          <Box>
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              sx={{
                backgroundColor: "#E2F1EB00",
                borderTop: "1px solid #E7EBEF",
                boxShadow: `0px 2px 7px 0px #45917326`,
                borderRadius: "8px",
                my: 2,
                p: 2,
                overflowX: "auto",
              }}
            >
              {paths?.map((path, index) => (
                <Stack
                  key={index}
                  sx={{
                    borderBottom: path_name === path ? "2px solid #459173" : "",
                    mx: 1,
                    px: 1,
                    cursor: "pointer",
                  }}
                  onClick={() => handle_path_name(path)}
                >
                  <Typography
                    sx={{
                      fontWeight: path_name === path ? 500 : 400,
                      color: path_name === path ? "#459173" : "#637D92",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {path}
                  </Typography>
                </Stack>
              ))}
            </Stack>
            {path_name === "Petition" && <AccountPetition />}
            {path_name === "Tagged" && <AccountTagged />}
            {path_name === "Signed petition" && <AccountSignedPetition />}
            {path_name === "Post" && <AccountPosts />}
            {path_name === "Replies" && <AccountReplies />}
            {path_name === "Bookmarks" && <AccountBookmark />}
          </Box>
        </Box>
      </Box>
    </ContentLayout>
  );
};

export default AccountContent;
